import * as actions from '../../constant/reduxActionTypes';

export const toggleLoading = value => {
  return {
    type: actions.SHOW_LOADING,
    showLoading: value
  };
};
